import { createSlice } from '@reduxjs/toolkit';

export const signupSlice = createSlice({
  name: 'signup',
  initialState: {
    loading: false,
    generalFormError: null,
    ownerOrSitterFormError: null,
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setGeneralFormError: (state, action) => {
      state.generalFormError = action.payload;
    },
    setOwnerOrSitterFormError: (state, action) => {
      state.ownerOrSitterFormError = action.payload;
    },
  },
});

export const {
  setLoading,
  setGeneralFormError,
  setOwnerOrSitterFormError,
} = signupSlice.actions;

export default signupSlice.reducer;
